import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgManyToOne = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 3.66602,
			cy: 4.33366,
			r: 1.375,
			transform: "rotate(90 3.66602 4.33366)",
			stroke: "currentColor",
			strokeWidth: .916667,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.333,
			cy: 8.00066,
			r: 1.375,
			transform: "rotate(90 12.333 8.00066)",
			stroke: "currentColor",
			strokeWidth: .916667,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 3.66602,
			cy: 11.6667,
			r: 1.375,
			transform: "rotate(90 3.66602 11.6667)",
			stroke: "currentColor",
			strokeWidth: .916667,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.33333 11.6667L6.66667 11.6667C7.40305 11.6667 8 11.0697 8 10.3333L8 5.66668C8 4.9303 7.40305 4.33334 6.66667 4.33334L5.33333 4.33334",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6667 8.00001L8.00008 8.00001",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export { SvgManyToOne as ReactComponent };
